export const coloursSort = [
    'Blue - Dark/Mid (287)',
    'Green - Dark (349)',
    'Red (485)',
    'Yellow (012)',
    'Blue - Light (284)',
    'Green - Mid (354)',
    'Green - Light (358)',
    'Orange (021)',
    'Gold - Metal (871)',
    'Silver - Metal (877)',
    'Bronze (876)',
    'Burgundy/Maroon (209)',
    'Purple (259)',
    'Custom Colour',
];

export const customColours = [
    'Brown (175)',
    'Cream (1205)',
    'Grey - Dark (425)',
    'Grey - Light (421)',
    'Green - Light (358)',
    'Purple - Light (257)',
    'Pink (190)',
    'Black (428)',
    'White (656)',
    'Turquoise (326)',
    'Bronze - Metal (876)',
];
